import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

export enum GetScheduledSurveysCacheKey {
  ScheduledSurveys = 'SCHEDULED_SURVEYS',
}

export const useGetPlannedSurveys = (teamId: number) => {
  const { fetchPlannedSurveys } = useServicesContext();
  return useQuery({
    queryKey: [GetScheduledSurveysCacheKey.ScheduledSurveys, teamId],
    queryFn: () => fetchPlannedSurveys(teamId),
    enabled: Boolean(teamId),
  });
};
